module.exports = __webpack_public_path__ + "img/cobbl3.36da4abd.jpeg";